export function dataLayerPush(data) {
  window.dataLayer = window.dataLayer || [];
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(() => {
    window.dataLayer.push(data);
  });
}
